/**
 * Staff support ticket routes — the scope-less staff pages for editing and
 * viewing a single support ticket, plus the generic error page. These sit
 * at the router root (no customer / plant / site layout), gated to staff.
 *
 * Contains:
 * - supportRoutes — a fragment of <Route> elements for the composer
 */
import React from 'react';
import { Route } from 'react-router-dom';

import { determineIsStaff } from '@sophocles/router/checkCredentials';
import { genericErrorPath, supportTicketEditPath, supportTicketViewPath } from '@sophocles/router/paths';
import RequireAuth from '@sophocles/router/RequireAuth';
import GenericErrorView from '@sophocles/views/errors/GenericErrorView';
import EditTicketView from '@sophocles/views/tickets/EditTicketView';
import TicketView from '@sophocles/views/tickets/TicketView';

export const supportRoutes = (
  <>
    <Route
      path={supportTicketEditPath.pattern}
      element={<RequireAuth component={EditTicketView} onEnter={determineIsStaff} />}
    />
    <Route
      path={supportTicketViewPath.pattern}
      element={<RequireAuth component={TicketView} onEnter={determineIsStaff} />}
    />

    <Route path={genericErrorPath.pattern} element={<RequireAuth component={GenericErrorView} />} />
  </>
);
